import { ApolloError } from "@apollo/client";

import { MagicRulesFileSpInitFragment } from "../../queries/useInitMagicRulesFile.generated";
import { ContextWorkbenchState } from "../contextWorkbenchState";
import { getEntityForMagicRulesFile } from "../utils/entity";

export type InitMagicRulesEntityPayload = {
  data: MagicRulesFileSpInitFragment | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
};

export function initMagicRulesEntity(
  state: ContextWorkbenchState,
  payload: InitMagicRulesEntityPayload,
): void {
  const { data, error, loading } = payload;

  state.entities.magicRulesFile.loading = loading;
  state.entities.magicRulesFile.error = error;

  const entity = data ? getEntityForMagicRulesFile(data) : undefined;
  state.entities.magicRulesFile.value = entity;
}

export type UpdateMagicRulesEntityPayload = {
  newContents: string | null;
};

export function updateMagicRulesEntity(
  state: ContextWorkbenchState,
  payload: UpdateMagicRulesEntityPayload,
): void {
  if (state.entities.magicRulesFile.value == null) return;
  state.entities.magicRulesFile.value.fileContent = payload.newContents;
}
